import { EthereumNetwork } from "../graphql.js"

const ethereum = {
    name: 'ethereum',
    title: 'Ethereum Mainnet',
    currency: 'ETH',
    check: true,
    regexp: '([\\W]|^)(0x[0-9a-fA-F]{40})([\\W]|$)',
    noregxp: [
        '([\\W]|^)(bnb[0-9a-z]{2})([\\W]|$)',
        '([\\W]|^)((cosmos1|terra1|tcro1|tcrocncl1)[a-zA-HJ-NP-Z0-9]{38,70})([\\W]|$)',
    ],
    query: (network: EthereumNetwork) => `query ($address: String!) {
    ${network}: ethereum(network: ${network}) {
      address(address: {is: $address}){ 
         balance
         balance_usd: balance(in: USD)
      }
      ins: transfers(receiver: {is: $address}) {
        count
        min_date: minimum(of: date)
        max_date: maximum(of: date)
      }
      currencyIn: transfers(receiver: {is: $address}) {
        count
        currency {
         symbol
         address
         tokenId
        }
      }
      outs: transfers(sender: {is: $address}) {
        count
        min_date: minimum(of: date)
        max_date: maximum(of: date)
      }
      currencyOut: transfers(sender: {is: $address}) {
       count
        currency {
         symbol
         address
         tokenId
       }
      }
    }
  }`,
}
export { ethereum }
